import Page from '@components/Page/Page'
import { TableFilters } from '@components/TableFilters'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import type { Permission as PermissionModel } from '@models/Permission'
import { roleNameDictionary } from '@models/Role'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getPermissions,
  selectPermissions,
  setPermissionQuery,
} from '@store/PermissionReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { Input, Space, Tag, Typography } from 'antd'

const { Text } = Typography

export const RolesAdminsPage = () => {
  const dispatch = useAppDispatch()
  const permissions = useAppSelector(selectPermissions())
  const { query, isLoading } = useAppSelector((state) => state.permission)

  const fetchRolesAndPermissions = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        current: 1,
        pageSize: 1000,
      },
      search: params.search,
    }
    dispatch(setPermissionQuery(newQuery))
    dispatch(getPermissions(newQuery))
  }

  const { handleFiltersChange, params } = useTableUrlSync<PermissionModel>({
    onParamsChange: fetchRolesAndPermissions,
  })

  const columns: TableColumnsType<PermissionModel> = [
    {
      title: 'Permission',
      key: 'name',
      width: 300,
      render: (record: PermissionModel) => <Text code>{record.name}</Text>,
    },
    {
      title: 'Description',
      key: 'description',
      render: (record: PermissionModel) => (
        <span style={{ color: '#8c8c8c' }}>{record.description}</span>
      ),
    },
    {
      title: 'Roles',
      key: 'roles',
      render: (record: PermissionModel) => (
        <Space wrap>
          {record.roles?.map((role: any) => (
            <Tag key={role.id} color="purple">
              {roleNameDictionary[role.name as keyof typeof roleNameDictionary]}
            </Tag>
          ))}
        </Space>
      ),
    },
  ]

  return (
    <Page
      permissions={Permission.listAdmin}
      pageTitle={{
        title: 'Roles & permissions',
        level: 4,
      }}
    >
      <TableFilters
        initialValues={{
          name: params.search.name,
        }}
        onValuesChange={handleFiltersChange}
        left={[]}
        right={[
          {
            name: 'name',
            type: 'search',
            label: 'Search by name',
            input: <Input placeholder="list user ..." allowClear />,
          },
        ]}
      />
      <SBTable
        columns={columns}
        dataSource={permissions}
        loading={isLoading}
        pagination={false}
      />
    </Page>
  )
}

export default RolesAdminsPage
